import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "flex items-center justify-between flex-wrap mt-2" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_newTable = _resolveComponent("newTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Documents")
      ], -1)),
      (_ctx.filesDataFiltered)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.filesDataFiltered.length === 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.filesDataFiltered.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5)),
              _cache[1] || (_cache[1] = _createTextVNode(" Filters "))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "headerText mt-3" }, " Document management, often referred to as Document Management Systems (DMS), is the use of a computer system and software to store, manage, and track electronic documents and electronic images of paper-based information captured through the use of a document scanner. Document management is how your organization stores, manages, and tracks its electronic documents. According to ISO 12651-2, a document is \"recorded information or object which can be treated as a unit.\" ", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.filesDataFiltered,
        headersData: _ctx.fileHeaders,
        navigate: true,
        fileNavigateId: 10002,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"])
    ])
  ]))
}